//
//
//
//
//
//
//
//
//
//
//
//

import { CycleIcon } from '@/components/elements'

export default {
  name: 'InboxItem',
  components: { CycleIcon },
  props: {
    isOpen: Boolean,
    isHidden: Boolean
  },
  methods: {
    handleClick(event) {
      this.$emit('open', event)
    }
  }
}
